export default __webpack_public_path__ + "static/media/image-ph-study-main-1-n-w@2x.c30a3e01.webp";